/* eslint react-hooks/immutability: ["warn"] */
import "../styles/RoomSettings.css";
import { ArticleIdNbrArticles, EdsData, SalesStopData } from "../types/article";
import { AggregatedArticle } from "../hooks/useAggregatedArticles";
import { AggregatedItemListViewItem } from "@coworker/apprestructured/src/media-maintenance/components/aggregated-items/AggegatedItemListViewItem/AggregatedItemListViewItem";
import { TaskLinks } from "@coworker/app/src/components/RoomSettings/types/taskLink";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { Item } from "@coworker/apprestructured/src/shared/types/item";

interface AggregatedArticleListItemProps {
  article: AggregatedArticle;
  media: Media;
  itemInfo: Item | null;
  itemInfoLoading: boolean;
  taskLinks?: TaskLinks;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  selectArticleIdsMode?: boolean;
  isSelected?: boolean;
  handleSelectedItems?: (articleIdNbrArticles: ArticleIdNbrArticles) => void;
}

export function AggregatedArticleListItem({
  article,
  edsData,
  salesStopData,
  selectArticleIdsMode,
  isSelected,
  handleSelectedItems,
  taskLinks,
  media,
  itemInfo,
  itemInfoLoading,
}: AggregatedArticleListItemProps) {
  const handleSelectedItemChange = () => {
    if (handleSelectedItems) {
      handleSelectedItems({
        articleId: article.id,
        nbrArticles: article?.nbrArticles || 0,
      });
    }
  };

  if (!article) return <></>;

  return (
    <>
      <AggregatedItemListViewItem
        edsData={edsData ?? null}
        salesStopData={salesStopData ?? null}
        selectArticleIdsMode={selectArticleIdsMode || false}
        isSelected={isSelected || false}
        article={article}
        taskLinks={taskLinks || []}
        media={media}
        itemInfo={itemInfo}
        itemInfoLoading={itemInfoLoading}
        handleSelectedItemChange={handleSelectedItemChange}
      />
    </>
  );
}
